import React, { Component } from 'react';
import './loader.css';

class Loader extends Component {
    componentDidMount() {
        window.scrollTo(0,0);
    }

    render() {
        return (
            <div className="loader">
                <h1 className="kwootloader">Laden..</h1>
            </div>
        );
    }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/loader/loader.js